export const toolbar = {
  minHeight: 51,
  landscape: 43,
  desktop: 59
} as const;

export const scrollbar = {
  width: '10px',
  height: '10px'
} as const;

export const zIndex = {
  fab: 1101
} as const;
